"use client";

import { useEffect, useRef, useState } from "react"; // GLOBAL CUSTOM COMPONENTS

import CategoryList from "src/lib/components/category-section/footmart/category-list";
import { SidebarContainer } from "./styles";
import useMediaQuery from "@mui/material/useMediaQuery";

// ==============================================================
const Sidebar = ({ categoryList, children }) => {
  const pageContentRef = useRef();
  const [sidebarHeight, setSidebarHeight] = useState(0);
  useEffect(() => setSidebarHeight(pageContentRef.current.offsetHeight), []);
  const isMobile = useMediaQuery("(max-width:767px)");
  return (
    <>
      {!isMobile && (
        <SidebarContainer>
          <div className="pageContent" ref={pageContentRef}>
            {children}
          </div>
          <CategoryList categoryList={categoryList || []} />
        </SidebarContainer>
      )}

      {isMobile && (
        <>
          <SidebarContainer>
            <div className="pageContent" ref={pageContentRef}>
              {children}
            </div>
          </SidebarContainer>
          <CategoryList categoryList={categoryList || []} />
        </>
      )}
    </>
  );
};

export default Sidebar;
